import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 4.5a2.34 2.34 0 0 1 1.73.78l9.81 11.15a1.85 1.85 0 1 1-2.77 2.44l-8.58-9.75a.25.25 0 0 0-.38 0l-8.58 9.75a1.85 1.85 0 1 1-2.77-2.44l9.81-11.15A2.34 2.34 0 0 1 12 4.5Z"
}), 'ChevronUp');